<p-confirmdialog
  [breakpoints]="{ '960px': '75vw', '640px': '95vw' }"
  [key]="dialogKey()"
  [pt]="{ root: { style: { borderRadius: 'var(--yt-grid-unit-3xl)' } } }"
  [style]="{ maxWidth: 'min(45rem, 92vw)' }"
>
  <ng-template
    #headless
    let-message
    let-onAccept="onAccept"
    let-onReject="onReject"
  >
    @if (message) {
      <div class="confirmation-container">
        <div class="app-confirm-icon" [ngClass]="iconStyleClass()">
          <i [class]="message.icon"></i>
        </div>
        <span class="confirmation-title title-large">{{ message.header }}</span>
        <p class="confirmation-message body-medium">{{ message.message }}</p>
        <div class="confirmation-buttons">
          <p-button
            class="w-full"
            severity="contrast"
            variant="outlined"
            [label]="message.rejectLabel"
            [pt]="{ root: { style: { width: '100%' } } }"
            (onClick)="onReject()"
          />
          <p-button
            class="w-full"
            [label]="message.acceptLabel"
            [pt]="{ root: { style: { width: '100%' } } }"
            [severity]="message.severity"
            (onClick)="onAccept()"
          />
        </div>
      </div>
    }
  </ng-template>
</p-confirmdialog>
